import { Pagination, TextField } from '@cimpress/react-components';
import React, { KeyboardEvent, useEffect, useMemo, useState } from 'react';
import { Select } from '../Select';

export interface TablePaginationProps {
  className?: string;
  page: number;
  pages: number;
  pageSize: number;
  pageSizeOptions: number[];
  showPageJump?: boolean;
  showPageSizeOptions?: boolean;
  onPageChange: (value: number) => void;
  onPageSizeChange: (value: number) => void;
}

// tslint:disable-next-line:function-name
export function TablePagination(
  {
    className,
    onPageChange,
    onPageSizeChange,
    page,
    pages,
    pageSize,
    pageSizeOptions,
    showPageJump,
    showPageSizeOptions,
  }: TablePaginationProps,
) {
  const [goToPage, setGoToPage] = useState('');
  const [current, setCurrent] = useState(page);
  const pageSizeSelectOptions = useMemo(
    () => pageSizeOptions.map(pageSize => ({ label: `${pageSize}`, value: `${pageSize}` })),
    [pageSizeOptions],
  );

  const selectedPageSizeOption = useMemo(
    () => ({ label: `${pageSize}`, value: `${pageSize}` }),
    [pageSize],
  );

  const onGoToPageSubmit = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const parsedPage = parseInt(goToPage, 10);
      if (!Number.isNaN(parsedPage)) {
        setCurrent(parsedPage - 1);
      }
    }
  };

  useEffect(
    () => {
      onPageChange(current);
    },
    [current],
  );

  return <div className={`${className} rt-pagination`}>
    {showPageSizeOptions && <Select
      tether
      clearable={false}
      label="Per Page"
      options={pageSizeSelectOptions}
      value={selectedPageSizeOption}
      onChange={value => !value || Array.isArray(value) ? undefined : onPageSizeChange(parseInt(value.value, 10))}
    />}
    {showPageJump && pages > 1 && <TextField
      label={'Go To'}
      value={goToPage}
      onChange={e => setGoToPage(e.currentTarget.value)}
      onKeyDown={onGoToPageSubmit}
    />}
    {pages > 1 && <Pagination
      initialPage={page}
      forcePage={current}
      pageCount={pages}
      onPageChange={({ selected }) => setCurrent(selected)}
      pageRangeDisplayed={5}
      marginPagesDisplayed={3}
    />}
  </div>;
}
